export default __webpack_public_path__ + "static/media/screen2.a2d14083.jpg";